module.exports = __webpack_public_path__ + "static/media/icon_donation.f3b4bb1e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/products/icon_donation.svg
// module id = 1815
// module chunks = 11